declare const importMeta: ImportMeta

export const RUNWARE_CONFIG = {
  apiKey: (import.meta as any).env?.VITE_RUNWARE_API_KEY || 'your-runware-api-key',
  baseUrl: 'https://api.runware.ai/v1',
  defaultModel: 'runware:100@1', // Requested Runware default model
  defaultSettings: {
    width: 1024,
    height: 1024,
    steps: 4,
    CFGScale: 1,
    scheduler: 'FlowMatchEulerDiscreteScheduler',
    outputFormat: 'JPEG',
    includeCost: true,
    outputType: ['URL'] as Array<'URL' | 'BASE64'>,
    negativePrompt: 'blurry, low quality, distorted, deformed, bad anatomy, duplicate, extra limbs, ugly, poorly drawn, watermark',
  },
}

export interface RunwareRequest {
  taskType: 'imageInference'
  model: string
  positivePrompt: string
  negativePrompt?: string
  width?: number
  height?: number
  steps?: number
  CFGScale?: number
  scheduler?: string
  outputFormat?: 'JPEG' | 'PNG'
  numberResults?: number
  outputType?: Array<'URL' | 'BASE64'>
  includeCost?: boolean
  seed?: number
}

export interface RunwareResponse {
  taskUUID: string
  imageURL?: string
  NSFWContent?: boolean
  timeTaken?: number
  error?: string
}
